import React from 'react'
import PropTypes from 'prop-types'


const BaseParagraph = ({children, illustration, align}) => {

    const style = {
        textAlign: align
    }

    return (<div className="text-block" style={style} >
            {illustration &&  <div className="illustration"><img src={illustration} alt=""/></div> }
            {/*<div dangerouslySetInnerHTML={{__html: children}}/>*/}
            <div>{children}</div>
        </div>
    )
}
;

BaseParagraph.propTypes = {
    children: PropTypes.any,
    illustration: PropTypes.string,
    align: PropTypes.string,
}


BaseParagraph.defaultProps = {
    align: "left"
}

export default BaseParagraph